<template>
  <div class="metrics__chart general">
    <CommonTitle :options="options_title" />
    <GameGeneral />
  </div>
</template>

<script>
import CommonTitle from "../../common/CommonTitle";
import CommonTable from "../../common/CommonTable";
import GameGeneral from "../charts/game/GameGeneral";

export default {
  name: "MetricGame",
  data() {
    return {
      options_title: {
        name: 'Метрики игры',
        id: 'metrics',
        actions: '',
      },
    };
  },
  mounted() {},
  components: {
    CommonTitle,
    CommonTable,
    GameGeneral,
  },
};
</script>

<style>
</style>